var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEffortlessRocketshipV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.2098 77.67C63.0643 76.2315 62.5912 74.8453 61.8268 73.6181C61.0623 72.3908 60.0268 71.3549 58.7998 70.59C57.2998 69.795 55.6648 69.96 54.1948 69.435C51.8248 68.58 52.3498 68.775 50.8048 66.24C49.6878 64.328 48.1569 62.6902 46.3244 61.4469C44.4919 60.2036 42.4043 59.3863 40.2148 59.055C39.6142 58.5835 38.917 58.2503 38.1729 58.0792C37.4287 57.908 36.656 57.9032 35.9098 58.065C28.9048 59.4 13.9048 62.565 13.9048 72.015C13.905 72.9247 14.1449 73.8183 14.6005 74.6057C15.0561 75.3931 15.7112 76.0465 16.4998 76.5C18.5617 77.4488 20.8464 77.8071 23.0998 77.535C22.8298 78.225 22.5748 78.915 22.3498 79.62C21.4198 82.5 20.3248 86.01 21.4048 88.98C22.9048 93.225 25.5148 93.6 28.3348 92.97C27.1798 96.735 26.8348 100.575 29.8348 103.605C33.9598 107.775 39.6448 104.895 44.3998 101.94C44.9757 102.491 45.6676 102.906 46.4248 103.155C47.9366 103.587 49.5404 103.578 51.0472 103.129C52.554 102.679 53.9011 101.809 54.9298 100.62C60.1948 95.31 64.4098 85.245 63.2098 77.67Z",
    fill: "#F1F1F1",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0205 42.96C62.5205 30.6 79.8155 22.59 94.8155 22.845C95.2074 22.8632 95.5784 23.0271 95.8559 23.3046C96.1333 23.582 96.2972 23.953 96.3155 24.345C96.6605 39.345 88.5605 56.58 76.1555 67.17L72.2105 70.365L58.1855 81.69C57.9013 81.9561 57.5248 82.1014 57.1355 82.095C56.9284 82.0983 56.7228 82.0587 56.5318 81.9787C56.3408 81.8986 56.1684 81.7799 56.0255 81.63L37.7255 62.88C37.4502 62.5877 37.2969 62.2014 37.2969 61.8C37.2969 61.3985 37.4502 61.0122 37.7255 60.72L47.3105 48.81",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1101 38.1C71.2689 38.0864 69.4799 38.7111 68.0475 39.8679C66.615 41.0246 65.6275 42.6419 65.253 44.4446C64.8784 46.2473 65.14 48.1241 65.9932 49.7556C66.8464 51.3872 68.2385 52.6729 69.9327 53.3938C71.6269 54.1147 73.5185 54.2264 75.2858 53.7099C77.0531 53.1934 78.5868 52.0806 79.6261 50.5608C80.6655 49.041 81.1461 47.2081 80.9864 45.3738C80.8267 43.5395 80.0364 41.8173 78.7501 40.5C77.2513 39.01 75.2235 38.1741 73.1101 38.175V38.1Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7646 77.52L41.6846 55.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.34 69.3149C30.0126 73.1075 23.7657 75.4022 17.25 75.9599L17.505 78.9599C24.5311 78.3544 31.2657 75.873 37.005 71.7749L35.34 69.3149ZM46.605 81.1349C41.6089 87.0914 37.8324 93.9718 35.49 101.385L38.37 102.255C40.6257 95.2673 44.1889 88.772 48.87 83.1149L46.605 81.1349ZM40.605 74.7749L27.105 88.7399L29.265 90.8249L42.765 76.8599L40.605 74.7749Z",
    fill: "url(#paint0_linear_33086_102064)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8154 26.775L92.4604 33.405",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2752 69.39V76.455L70.2452 85.485L65.2202 80.475",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7698 39.975H42.7048L33.6748 49.005L38.6998 54.03",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33086_102064",
    x1: 32.46,
    y1: 102.255,
    x2: 17,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FF9793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FF8AA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF80B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FF66D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4900FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEffortlessRocketshipV2);
export default __webpack_public_path__ + "static/media/icon-effortless-rocketship-v2.ec5ee01cb1042f98626a058fd379a5f0.svg";
export { ForwardRef as ReactComponent };